var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"r6x9T21tLJFOTHvCsMDBR"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

// handles individual event objects and transactions
Sentry.init({
  dsn: SENTRY_DSN,

  environment: process.env.NEXT_PUBLIC_NODE_ENV || 'development',

  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps

  sampleRate: process.env.NEXT_PUBLIC_SENTRY_LOCAL ? 0.0 : 0.5, // default sample rate for Error Events
  
  // handles sample rate for Transaction Events (transaction don't have to be errors)
  tracesSampler: (samplingContext) => {
    const { transactionContext, parentSampled, location, ...customContext } = samplingContext;
    const { name, op, tags } = transactionContext;
    // Examine provided context data and global namespace to compute the sample rate
    // contents of `samplingContext`
    const test = true;
    // return between 0.0 - 1.0
    // 0.0 forces do not send event
    // 1.0 forces send event
    if (process.env.NEXT_PUBLIC_SENTRY_LOCAL) {
      return 0.0; // do not send events to sentry when running locally
    } else if (test) {
      // These are important - take a big sample
      return 0.5;
    } else if ("...") {
      // These are less important or happen much more frequently - only take 1%
      return 0.01;
    } else if ("...") {
      // These aren't something worth tracking - drop all transactions like this
      return 0;
    } else {
      // Default sample rate
      return 0.1;
    }
  }
});
